import { ReactElement } from 'react'
import { MyLocation } from '@mui/icons-material'
import { Alert, Button, Divider, Typography } from '@mui/material'

interface Props {
  label: string
  onJump: () => void
}

/**
 * Info block for an element-linked comment, shared between the CommentDrawer's settings panel and
 * the in-scene CommentEditPopup: the linked element's label, a hint that the text is owned by the
 * position list, and a "jump to element" action. Purely presentational — the label and jump
 * behavior come from the caller, because the popup renders this inside a drei <Html> portal where
 * router/hook context isn't available (see CommentEditPopup).
 */
const LinkedCommentInfo = ({ label, onJump }: Props): ReactElement => (
  <>
    <Typography variant="h6">{label}</Typography>
    <Alert severity="info" sx={{ py: 0.25, '& .MuiAlert-message': { fontSize: 12 } }}>
      Der Text dieses verknüpften Kommentars kann nur über das Kommentar-Textfeld in der
      Ergebnis-Ansicht bearbeitet werden.
    </Alert>
    <Button
      variant="outlined"
      size="small"
      startIcon={<MyLocation fontSize="small" />}
      onClick={onJump}
      data-cy="comment-jump-to-element"
    >
      Zum Element springen
    </Button>
    <Divider />
  </>
)

export default LinkedCommentInfo
